<template>
  <div>
<!--    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">-->
<!--      <ol class="carousel-indicators">-->
<!--        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>-->
<!--        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>-->
<!--        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>-->
<!--      </ol>-->
<!--      <div class="carousel-inner">-->
<!--        <div class="carousel-item active">-->
<!--          <img src="../assets/Banner01.jpg" class="d-block w-100" alt="...">-->
<!--        </div>-->
<!--        <div class="carousel-item">-->
<!--          <img src="../assets/Banner01.jpg" class="d-block w-100" alt="...">-->
<!--        </div>-->
<!--        <div class="carousel-item">-->
<!--          <img src="../assets/Banner01.jpg" class="d-block w-100" alt="...">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <img src="../assets/about-banner.jpg" class="img-fluid w-100" alt="aboutbanner">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">关于我们</div>
              <menu class="menu pull-left" id="menu">
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="cur underline " >企业动态</router-link></div>-->
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">代理品牌动态</router-link></div>-->
                <!--                <div class="pull-left paddingleft15"><router-link to="/" class="underline text66">行业资讯</router-link></div>-->
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_1}" @click="changeTab(0)">企业动态</a></div>-->
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_2}" @click="changeTab(1)">代理品牌动态</a></div>-->
<!--                <div class="pull-left paddingleft15"><a href="javascript:void(0);" class="underline text66" :class="{'cur':nav_status_3}" @click="changeTab(2)">行业资讯</a></div>-->
              </menu>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <em>关于我们</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!-- Feature Area Starts -->
    <section class="feature-area" style="padding-top: 20px; padding-bottom: 20px">
      <div class="container">

        <div class="row">
          <div class="col-lg-3 contleft">
            <div class="wrapper">
              <!-- Sidebar -->
              <nav id="sidebar">
                <div class="sidebar-header">
                  <h2 class="leftTitle">关于我们</h2>
                </div>

                <div class="leftNav">
                  <ul class="list-unstyled components">
                    <li v-for="(list,index) in menuList">
                      <div v-if="list.children != undefined && list.children != null && list.children != '' ">
                        <a :href="'#submenu'+index" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle leftNavCur">{{list.menuName}}</a>
                        <ul class="collapse list-unstyled" :id="'submenu'+index">
                          <li v-for="(sublist, subindex) in list.children">
                            <a href="#" class="leftNavCur2"> - {{sublist.menuName}}</a>
                          </li>
                        </ul>
                      </div>
                      <div v-else>
                        <a href="javascript:void(0);" :key="index" @click="getInfo(list.id)">{{list.menuName}}</a>
                      </div>

                    </li>

<!--                    <li>-->
<!--                      <a href="#homeSubmenu2" data-toggle="collapse" aria-expanded="true" class="dropdown-toggle">企业信仰</a>-->
<!--                      <ul class="collapse list-unstyled" id="homeSubmenu2">-->
<!--                        <li>-->
<!--                          <a href="#" class="leftNavCur2"> - Home 1</a>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                          <a href="#" class="leftNavCur2"> - Home 2</a>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                          <a href="#" class="leftNavCur2"> - Home 3</a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </li>-->
<!--                    <li>-->
<!--                      <a href="#">企业活动</a>-->
<!--                    </li>-->
                  </ul>
                </div>
              </nav>

            </div>
          </div><!--contleft/-->
          <div class="col-lg-8 contright">
            <h2 class="rightTitle">{{aboutInfo.menuName}}</h2>
            <div class="Article">
                 <p v-html="aboutInfo.dscr"></p>
            </div>
          </div><!--contright/-->
          <div class="clears"></div>
        </div><!--width1200/-->
      </div>
    </section>
    <!-- Feature Area End -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      menuList: [],
      aboutInfo: {},
    }
  },
  methods: {
    // 获取菜单
    getMenu() {
      const vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/menu/getMenu',
        needLogin: false,
        params: {
          type: 2
        },
      }).then((response) => {
        if (response.status === 200) {
          const responseData = response.data.data;
          console.log(responseData);
          vm.menuList = responseData;
          if(vm.menuList[0].id != undefined && vm.menuList[0].id != null && vm.menuList[0].id != ''){
            vm.getInfo(vm.menuList[0].id);
          }
        }
      });
    },
    getInfo(id) {
      const vm = this;

      vm.$_axios({
        method: 'post',
        url: '/mapis/about/getInfo',
        needLogin: false,
        params: {
          id: id
        },
      }).then((response) => {
        if (response.status === 200) {
          const responseData = response.data.data;
          console.log(responseData);
          vm.aboutInfo = responseData;
        }
      });
    },
  },
  created() {
    let vm = this;
    console.log('created')
    vm.getMenu();

  },
  mounted() {
    let vm = this;
  },
};
</script>




// WEBPACK FOOTER //
// About.vue?44af9b74